<template>
  <div
    class="pt-3 px-3 pb-2"
    :class="backgroundClass"
  >
    <!-- TextField rendered as <input> -->
    <v-text-field
      v-if="!field.data.multiline"
      :value="value"
      type="text"
      :label="noLabel ? '' : field.data.label"
      :placeholder="field.data.placeholder"
      :rules="field.rules"
      :required="field.required"
      :counter="field.schema.maxLength"
      :style="field.data.css ? field.data.css.field : null"
      :clearable="
        field.data.clearable !== undefined ? field.data.clearable : true
      "
      clear-icon="add_circle"
      class="rotate-clear-icon-to-look mt-0"
      :disabled="disabled"
      data-cy="overlay-data-textfield"
      @focus="onInputFocused"
      @input="onTextChanged"
    />
    <!-- Multiline TextField rendered as <textarea> -->
    <v-textarea
      v-if="field.data.multiline"
      :value="value"
      type="text"
      :label="noLabel ? '' : field.data.label"
      :placeholder="field.data.placeholder"
      :rules="field.rules"
      :required="field.required"
      :counter="field.schema.maxLength"
      :style="field.data.css ? field.data.css.field : null"
      :rows="field.data.rows"
      :auto-grow="field.data.autogrow"
      :no-resize="field.data.resize === true ? false : true"
      :clearable="
        field.data.clearable !== undefined ? field.data.clearable : true
      "
      clear-icon="add_circle"
      class="rotate-clear-icon-to-look mt-0"
      :disabled="disabled"
      data-cy="overlay-data-textfield"
      @focus="onInputFocused"
      @input="onTextChanged"
    />
  </div>
</template>

<script>
import {OverlayOptionsField} from '@/mixins/overlayOptions.js';

export default {
  props: {
    field: {
      type: OverlayOptionsField,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    backgroundClass: {
      type: String,
      default: 'overlay-options-field-bg',
    },
  },
  methods: {
    onInputFocused(event) {
      if (this.field && this.field.data && this.field.data.select_on_focus) {
        event.target.select();
      }
    },
    onTextChanged(value) {
      if (value === null) {
        value = '';
      }
      this.$emit('update:value', value);
    },
  },
};
</script>

<style scoped>
.rotate-clear-icon-to-look >>> .v-input__icon--clear {
  transform: rotateZ(45deg);
}
</style>



// WEBPACK FOOTER //
// src/components/OverlayDataTextField.vue